import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getReferans, getReferansTypes, updateReferans } from '../api/referansApi'
import type { ReferansUpdate } from '../types'

const KEY = 'admin-referans'

/**
 * Referans sunucu-durumu: TİP filtreli/aramalı liste + TİP seçenekleri + ad güncelleme (018).
 *
 * <p>`listEnabled` false iken liste **hiç sorgulanmaz** (ekran ilk açılışı: tip seçilmemiş ve arama boş —
 * tüm referansları çekmek anlamsız/pahalı). TİP seçenekleri her zaman yüklenir (combo'yu doldurur).
 */
export function useReferans(type: string | null, q: string, listEnabled = true) {
  const qc = useQueryClient()
  const list = useQuery({
    queryKey: [KEY, type ?? '', q],
    queryFn: () => getReferans(type ?? undefined, q),
    enabled: listEnabled,
  })
  const types = useQuery({ queryKey: [KEY, 'types'], queryFn: getReferansTypes })

  const update = useMutation({
    mutationFn: ({ id, body }: { id: number; body: ReferansUpdate }) => updateReferans(id, body),
    // Kaydetme sonrası listeyi tazele → Ad sütunları güncel.
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  })

  return { list, types, update }
}
